import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'

export interface InvalidSelectedDateRangeExportSessionDialogProps {
  open: boolean
  onClose: () => void
  place: number
}

/**
 * Dialog component to inform user that selected date range is more than one year.
 * @params - all params that comes from ModalRoot
 */
export const InvalidSelectedDateRangeExportSessionDialog: React.VFC<InvalidSelectedDateRangeExportSessionDialogProps> = ({
  open,
  place,
  onClose,
}) => {
  const { t } = useCustomTranslation()

  return (
    <Dialog
      maxWidth={'sm'}
      title={t('emobility.chargingSession.invalid-date')}
      onClose={onClose}
      place={place}
      actions={{
        secondary: {
          name: t('common.ok'),
        },
      }}
    />
  )
}
